export const recruitmentTimeline = [
  {
    "id": "01",
    "date": "8/28",
    "subtitle": "Application Opens!",
    "information": [
      { "text": "Applications are now open for Fall 2026!" }
    ]
  },
  {
    "id": "02",
    "date": "8/26 – 9/6",
    "subtitle": "Coffee Chats",
    "information": [
      { "text": "Schedule through " },
      { "text": "Open Portal", "href": "https://portal.openprojectberkeley.com" },
      { "text": ". Coffee chats can be duo or individual, so bring a friend if you would like!" }
    ]
  },
  {
    "id": "03",
    "date": "8/28",
    "subtitle": "DataBytes",
    "information": [
      { "text": "Join us for DataBytes on " },
      { "text": "Friday, Aug 28th in Hearst Field Annex A1 @ 8PM", "highlight": true },
      { "text": "!" }
    ]
  },
  {
    "id": "04",
    "date": "8/31",
    "subtitle": "Infosession #1",
    "information": [
      { "text": "Our first infosession is on " },
      { "text": "Monday, Aug 31st in GPBB 100 @ 8PM", "highlight": true },
      { "text": "." }
    ]
  },
  {
    "id": "05",
    "date": "9/4",
    "subtitle": "Infosession #2",
    "information": [
      { "text": "Our second infosession is on " },
      { "text": "Friday, Sep 4th in VLSB 2040 @ 8PM", "highlight": true },
      { "text": "." }
    ]
  },
  {
    "id": "06",
    "date": "9/5",
    "subtitle": "Application Due!",
    "information": [
      { "text": "Applications are due " },
      { "text": "@12:00 PM (noon)", "highlight": true },
      { "text": " on Sep 5th." }
    ]
  },
  {
    "id": "07",
    "date": "9/11",
    "subtitle": "Welcome Night",
    "information": [
      { "text": "Welcome Night is on " },
      { "text": "Friday, Sep 11th", "highlight": true },
      { "text": " (invite only)." }
    ]
  }
];
